import { globalErrorMsg } from '@bingads-webui-campaign/hotel-common-upsert';
import { validateBidAdjustment, isValueOverlap } from '../components/utility';
import { validateLengthOfStayDays } from './utility';

export function getLengthOfStayBasicConfig(i18n) {
  const columns = [
    {
      key: 'minimum-number', name: i18n.getString(_TL_('Minimum number of nights')), fieldName: 'minimumNumber', minWidth: 188, maxWidth: 188, type: 'input', className: 'border-right', headerClassName: 'target-custom-header',
    },
    {
      key: 'maximum-number', name: i18n.getString(_TL_('Maximum number of nights')), fieldName: 'maximumNumber', minWidth: 198, maxWidth: 198, type: 'input', className: 'border-right', headerClassName: 'target-custom-header',
    },
  ];
  return {
    basicConfig: {
      columns,
      showAddBtn: true,
      showSettingToggle: true,
      titleKey: i18n.getString(_TL_('Length of stay')),
      topicKey: 'pop_BA_CampaignTargets_LengthOfStay',
      extraClass: 'length-of-stay-container',
      maxLimit: 30,
      minBid: -90,
      maxBid: 900,
      extraBid: [-100],
    },
  };
}


export const lengthOfStayDefaultSetting = [{
  minimumNumber: '',
  maximumNumber: '',
  bidAdjustmentDropdown: 'Increase by',
  bidAdjustmentInput: 0,
}];

export const isLengthOfStayTargetValid = (lengthOfStay, patchErrMsg = function () { }) => {
  let isValid = true;

  lengthOfStay.filter(item => item.Status !== 'Deleted').forEach((item) => {
    let validateValue = item.bidAdjustmentInput;
    if (item.bidAdjustmentDropdown === 'Decrease by') {
      validateValue = -validateValue;
    }
    if (validateBidAdjustment({
      value: validateValue, min: -90, max: 900, extra: [-100],
    }) || validateLengthOfStayDays({ value: item.minimumNumber }) || validateLengthOfStayDays({ value: item.maximumNumber })) {
      isValid = false;
    }
  });
  if (isValueOverlap('lengthOfStay', lengthOfStay)) {
    isValid = false;
  }
  if (isValid) {
    patchErrMsg('lengthOfStay', '');
  } else {
    patchErrMsg('lengthOfStay', globalErrorMsg);
  }
  return isValid;
};
